import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setSignupData } from '../../../redux/signup';
import { validate, validateEmail, VALIDATOR_EMAIL, VALIDATOR_MATCHING_VALUES, VALIDATOR_REQUIRE } from '../../../helpers/Validators'
import { emailIsExistsInSystem, register } from "../../../services/accountService";
import { Link } from "react-router-dom";
import { LOGIN } from "../../../navigation/Constants";
import { GACategoryName, GAEventNames, GAUniqueEventIds, GenderType } from "../../../helpers/Enums";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

const EmailQuestion = (props: any) => {
    const dispatch = useDispatch();
    const resgiter = useSelector((state: RootState) => state.signup);
    const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 3));

    const [email, setEmail] = useState<string>(resgiter.email);
    const [emailMatch, setemailMatch] = useState<string>(resgiter.email);
    const [errors, setErrors] = useState<any>({});
    const [canMoveStep, setCanMoveStep] = useState<boolean>(false);


    const validateForm = async () => {
        let errors: any = {};
        if (!validate(email, [VALIDATOR_REQUIRE()])) {
            errors["email"] = "חובה להזין דואר אלקטרוני";
        }
        if (!validate(email, [VALIDATOR_EMAIL()])) {
            errors["email"] = "כתובת המייל לא תקינה. שננסה שוב?";
        }
        if (!validate(emailMatch, [VALIDATOR_REQUIRE()])) {
            errors["emailMatch"] = "חובה לחזור על דואר אלקטרוני";
        }
        if (!validate(email, [VALIDATOR_MATCHING_VALUES(emailMatch)])) {
            errors["emailMatch"] = "כתובות המייל לא זהות. שננסה שוב?";
        }
        if (Object.keys(errors).length === 0) {
            const { data: emailIsExists } = await emailIsExistsInSystem(email);
            if (emailIsExists) {
                errors["email"] = "המייל זה כבר מופיע אצלנו במערכת. אולי זו טעות הקלדה, או שכבר נרשמת אלינו בעבר :)";
            }
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (await validateForm()) {
            resgiter.email = email;
            dispatch(setSignupData(resgiter))
            props.next()

            recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 3", "אישור מייל", GAUniqueEventIds.APP_SIGNUP)

        }
    };


    const enabled =
        email.length > 0 && emailMatch.length > 0;


    return (
        <>
            <div className="content_sec wf-section">

                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">{question && question[0].question}</h2>
                    <div>{question && question[0].questionSubTitle}</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmit} noValidate={true}>
                        <div className="form_field_content login">
                            <div className="field_block">
                                {/* <label htmlFor="email">הקלידו כתובת דואר אלקטרוני</label> */}
                                <input autoComplete="off" name="email" inputMode="email" type="email" dir="ltr" value={email} placeholder="מייל" onChange={e => setEmail(e.target.value)} maxLength={256} className="txt_field mail w-input" />
                                <div className="form_allert" style={{ display: errors && errors["email"] ? "contents" : "block" }}>{errors["email"]}</div>
                            </div>
                            <div className="field_block">
                                <label htmlFor="name">אישור כתובת מייל</label>
                                <input autoComplete="off" name="emailMatch" inputMode="email" type="email" value={emailMatch} placeholder={resgiter.genderId === GenderType.MALE ? "הקלד שוב את כתובת המייל" : "הקלידי שוב את כתובת המייל"} onChange={e => setemailMatch(e.target.value)} maxLength={256} className="txt_field mail w-input" />
                                <div className="form_allert" style={{ display: errors && errors["emailMatch"] ? "contents" : "block" }}>{errors["emailMatch"]}</div>
                            </div>
                            <input autoComplete="off" disabled={!enabled} type="submit" value="בואו נמשיך" data-wait="" className={enabled ? "button_full  w-button" : "button_full inactive  w-button"}></input>
                            <div><Link to={LOGIN} style={{ textDecoration: "underline" }}> כניסה לחברים רשומים</Link></div>
                        </div>
                        {/* <input autoComplete="off" disabled={!enabled} type="submit" value="המשך" data-wait="" className={enabled ? "button_full w-button" : "button_full send w-button"}></input> */}
                    </form>
                </div>
            </div>
        </>
    )
}

export default EmailQuestion;